export const REQUIRED_ONBOARDING_TASKS = 3;

export interface IOnboardingCompletion {
	isKybCompleted: boolean;
	isFirstProductionApiKey: boolean;
	isProductionWebhookUrl: boolean;
	requiredCompletedCount: number;
	isOnboardingComplete: boolean;
}

export const resolveOnboardingCompletion = (
	user?: { approvedForLive?: boolean } | null,
	developerIntegration?: { hasApiSecret?: boolean; webhook?: { url?: string } } | null
): IOnboardingCompletion => {
	const isKybCompleted = !!user?.approvedForLive;
	const isProductionWebhookUrl = !!developerIntegration?.webhook?.url;

	const isFirstProductionApiKey = !developerIntegration?.hasApiSecret;

	const requiredCompletedCount = !isKybCompleted
		? 0
		: [isKybCompleted, !isFirstProductionApiKey, isProductionWebhookUrl].filter(Boolean).length;

	return {
		isKybCompleted,
		isFirstProductionApiKey,
		isProductionWebhookUrl,
		requiredCompletedCount,
		isOnboardingComplete: requiredCompletedCount === REQUIRED_ONBOARDING_TASKS,
	};
};
